import React, { useEffect } from "react";
import Login from "./screens/Login";
import Dashboard from "./containers/Dashboard";
import SelectLocation from "./screens/SelectLocation";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Route, Switch } from "react-router-dom";
import QuickSettings from "./screens/QuickSettings";
import ForgotPassword from "./screens/ForgotPassword";
import Permissions from "./screens/Permissions";
import { getGeneralRoutes } from "./utils/routes/Routes";
import { Backdrop } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import cloudStore, { cloudStoreEvents } from "./store/CloudStore";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ToastContainer } from "react-toastify";

axios.defaults.withCredentials = true;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: "#fff",
  },
}));

export default function App() {
  const classes = useStyles();
  const [generalRoutes, setGeneralRoutes] = React.useState(
    getGeneralRoutes().reduce((routes, link) => {
      if (link.subLinks) {
        routes = routes.concat(
          link.subLinks.map((link) => {
            return <Route path={link.path} component={link.component} key={link.getLink()} />;
          })
        );
      } else {
        routes.push(<Route path={link.path} component={link.component} key={link.getLink()} />);
      }
      return routes;
    }, [])
  );
  const [isLoading, setIsLoading] = React.useState(cloudStore.loading);

  const loadingUpdated = () => {
    setIsLoading(cloudStore.loading);
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.LOADING_UPDATED, loadingUpdated);
    return () => {
      cloudStore.removeListener(cloudStoreEvents.LOADING_UPDATED, loadingUpdated);
    };
  }, []);

  return (
    <>
      <Backdrop open={isLoading} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route path="/select" component={SelectLocation} />
        <Route path="/quick/:id" component={QuickSettings} />
        <Route path="/permissions" component={Permissions} />
        <Route path="/home/:merchantId" component={Dashboard} />
        {generalRoutes}
        <Route path="/" component={Login} />
      </Switch>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
